import { render, staticRenderFns } from "./NextMoveHeader.vue?vue&type=template&id=17447396&scoped=true"
import script from "./NextMoveHeader.vue?vue&type=script&lang=ts"
export * from "./NextMoveHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17447396",
  null
  
)

export default component.exports